/** @format */

import {PeriodLiteModel} from 'components/PeriodSelectorLite/model';

import {ReportFileFormat} from '../Report/types';

export const PERIODS_MODEL: PeriodLiteModel[] = [
  {
    days: 15,
    name: '15 дней',
  },
  {
    days: 30,
    name: '30 дней',
  },
  {
    days: 60,
    name: '60 дней',
  },
  {
    days: 90,
    name: '90 дней',
  },
];

export const DEFAULT_PERIOD = 15;

export const ALL_FILE_FORMATS: ReportFileFormat[] = ['pdf', 'xlsx', 'html'];
